import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=4156dfb0&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4156dfb0')) {
      api.createRecord('4156dfb0', component.options)
    } else {
      api.reload('4156dfb0', component.options)
    }
    module.hot.accept("./FormDetail.vue?vue&type=template&id=4156dfb0&", function () {
      api.rerender('4156dfb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/FormDetail.vue"
export default component.exports